var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-hint"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto pr-2"},[_c('font-awesome-icon',{attrs:{"icon":"exclamation-circle"}})],1),_c('div',{staticClass:"col pl-0"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }